import { IS_IO } from 'lib/site';

function isLocalHostname(host?: string): boolean {
  if (!host) return false;
  return host === 'localhost' || host === '127.0.0.1' || host.endsWith('.localhost');
}

function resolveApiOrigin(): string {
  if (typeof window !== 'undefined' && !isLocalHostname(window.location.hostname)) {
    return 'https://api.examing.uz';
  }
  const env = process.env.REACT_APP_API_URL;
  if (env && (!env.includes('localhost') || (typeof window !== 'undefined' && isLocalHostname(window.location.hostname)))) {
    return env;
  }
  return typeof window !== 'undefined' && isLocalHostname(window.location.hostname)
    ? 'http://localhost:4000'
    : 'https://api.examing.uz';
}

export function resolveLandingUrl(): string {
  // app.examing.io links back to its own landing, never to the Uzbek one.
  if (IS_IO && typeof window !== 'undefined' && !isLocalHostname(window.location.hostname)) {
    return 'https://examing.io';
  }
  if (typeof window !== 'undefined' && !isLocalHostname(window.location.hostname)) {
    const env = process.env.REACT_APP_LANDING_URL;
    if (env && !env.includes('localhost')) {
      return env.replace(/\/$/, '');
    }
    return 'https://examing.uz';
  }
  const env = process.env.REACT_APP_LANDING_URL;
  if (env && (!env.includes('localhost') || (typeof window !== 'undefined' && isLocalHostname(window.location.hostname)))) {
    return env.replace(/\/$/, '');
  }
  return typeof window !== 'undefined' && isLocalHostname(window.location.hostname)
    ? 'http://localhost:3003'
    : 'https://examing.uz';
}

const apiOrigin = resolveApiOrigin();
const landingUrl = resolveLandingUrl();

const config = {
  landing_url: landingUrl,
  api: {
    base_url: apiOrigin.replace(/\/$/, ''),
    ws_url: process.env.REACT_APP_WS_URL || (apiOrigin.startsWith('https') ? `wss://${apiOrigin.replace(/^https?:\/\//, '')}` : apiOrigin.replace(/^http/, 'ws')),
    access_token_key: 'accessToken',
    refresh_token_key: 'refreshToken',
    active_org_key: 'activeOrganizationId',
    // No-account guest session token (sessionStorage). Sent as Bearer on attempt
    // requests ONLY when there is no logged-in user access token.
    guest_token_key: 'guestSessionToken',
  },
  // Google OAuth Web client id. Empty when unset → the "Continue with Google"
  // button is hidden and Google sign-in is disabled.
  google: {
    client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  },
  // Telegram Login Widget bot username (without the leading @). Empty when unset
  // → the Telegram button is hidden and Telegram sign-in is disabled. Must match
  // the bot whose token backs the API's TELEGRAM_BOT_TOKEN, and that bot's domain
  // must be linked in BotFather (/setdomain) to this app's origin.
  telegram: {
    // examing.io never offers Telegram sign-in (global B2B audience).
    bot_username: IS_IO ? '' : (process.env.REACT_APP_TELEGRAM_BOT_USERNAME || '').replace(/^@/, ''),
  },
};

export default config;
